import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { ErrorPage } from "./components/ErrorPage";
import LoginPage from "./components/login";
import Dashboard from "./components/Dashboard";
import UserAdminPage from "./components/pages/admin/UserAdminPage";
import AgilysysPayOnboardingForm from "./components/pages/Pay/AgilysysPayOnboardingForm";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/user-admin" element={<UserAdminPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/pay-onboarding" element={<AgilysysPayOnboardingForm />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
